import { Button } from '@mui/material'
import BarChartIcon from '@mui/icons-material/BarChart'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface ViewAnalysisButtonProps {
  entity: string
  id: string
  'data-tour-id'?: string
}

const ViewAnalysisButton: React.FC<ViewAnalysisButtonProps> = ({
  entity,
  id,
  'data-tour-id': dataTourId,
}) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(`/${entity}/view-analysis/${id}`)
  }

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleNavigate}
      startIcon={<BarChartIcon />}
      data-tour-id={dataTourId}
    >
      {t('buttons.viewAnalysis')}
    </Button>
  )
}

export default ViewAnalysisButton
